<template>
  <div class="supply-demand-page">
    <div class="page-header">
      <h1>供需池</h1>
      <p class="page-subtitle">发布需求，对接资源，实现供需匹配</p>
    </div>

    <div class="action-bar">
      <button class="btn-primary" @click="showPostModal = true">
        发布需求
      </button>
      <button class="btn-secondary" @click="goToResources">
       我有资源 + 
      </button>
    </div>

    <div class="demands-list">
      <DemandCard 
        v-for="demand in demands" 
        :key="demand.id" 
        :demand="demand"
      />
    </div>

    <div class="page-footer" v-if="demands.length > 0">
      <p>共 {{ demands.length }} 条需求</p>
    </div>

    <PostDemandModal 
      v-if="showPostModal" 
      @close="showPostModal = false"
      @submit="handlePostDemand"
    />
    <AddResourceModal 
      v-if="showAddResourceModal" 
      @close="showAddResourceModal = false"
      @submit="handleAddResource"
    />
  </div>
</template>

<script>
import DemandCard from '@/components/DemandCard.vue'
import PostDemandModal from '@/components/PostDemandModal.vue'
import AddResourceModal from '@/components/AddResourceModal.vue'
import axios from 'axios'

export default {
  name: 'SupplyDemandView',
  components: {
    DemandCard,
    PostDemandModal,
    AddResourceModal
  },
  data() {
    return {
      demands: [],
      showPostModal: false,
      showAddResourceModal: false
    }
  },
  mounted() {
    this.fetchDemands()
  },
  methods: {
    async fetchDemands() {
      try {
        const response = await axios.get('https://moodsci.com/Backend/lable/getRelaseDemand')
        console.log(response.data.data);
        
        if (response.data.data && Array.isArray(response.data.data)) {
          this.demands = response.data.data.map(item => ({
            id: item.id,
            title: item.title,
            description: item.content,
            category: item.hangye,
            publisher: item.username,
            price: item.price,
            type: item.type,
            image: item.img,
            createTime: item.createTime,
            tags: item.hangye ? [item.hangye] : [],
            contact: '',
            status: '进行中'
          }))
        }
      } catch (error) {
        console.error('获取需求列表失败:', error)
      }
    },
    handlePostDemand(newDemand) {
      this.demands.unshift(newDemand)
      this.showPostModal = false
    },
    handleAddResource(newResource) {
      this.demands.unshift(newResource)
      this.showAddResourceModal = false
    },
    goToResources() {
      this.$router.push('/resources')
    }
  }
}
</script>

<style scoped>
.supply-demand-page {
  min-height: 100vh;
  background: #f5f7fa;
  padding: 20px;
}

.page-header {
  text-align: center;
  margin-bottom: 32px;
  padding: 40px 20px;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  border-radius: 16px;
  color: #fff;
}

.page-header h1 {
  margin: 0 0 12px 0;
  font-size: 32px;
  font-weight: 700;
}

.page-subtitle {
  margin: 0;
  font-size: 16px;
  opacity: 0.9;
}

.action-bar {
  text-align: center;
  margin-bottom: 32px;
  white-space: nowrap;
}

.btn-primary,
.btn-secondary {
  display: inline-block;
  padding: 12px 32px;
  border-radius: 24px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 0 12px;
  border: none;
}

.btn-primary {
  background: linear-gradient(135deg, #42b983 0%, #35495e 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(66, 185, 131, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(66, 185, 131, 0.4);
}

.btn-secondary {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(30, 60, 114, 0.3);
}

.btn-secondary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(30, 60, 114, 0.4);
}

.demands-list {
  max-width: 800px;
  margin: 0 auto;
}

.page-footer {
  text-align: center;
  padding: 24px;
  color: #666;
  font-size: 14px;
}

@media (max-width: 768px) {
  .supply-demand-page {
    padding: 16px;
  }

  .page-header {
    padding: 30px 16px;
    margin-bottom: 24px;
  }

  .page-header h1 {
    font-size: 24px;
  }

  .page-subtitle {
    font-size: 14px;
  }

  .action-bar {
    display: flex;
    flex-wrap: nowrap;
    gap: 8px;
  }

  .btn-primary,
  .btn-secondary {
    flex: 1;
    margin: 0;
    padding: 10px 16px;
    font-size: 14px;
    white-space: nowrap;
  }
}
</style>
